import axios from 'axios';
import { handleResponse } from '../../utils/apiHandler';

const API_BASE = process.env.REACT_APP_API_ENDPOINT;

function getAuthHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem('access_token')}` };
}

// Fetch all company members
export function fetchCompanyMembers() {
  return axios.get(`${API_BASE}/api/accounts/company/members/`, { headers: getAuthHeaders() })
    .then(res => res.data)
    .catch(async err => {
      const errorMsg = err.response?.data?.error || err.message || 'Failed to fetch company members';
      throw new Error(errorMsg);
    });
}

// Fetch company members with optional search
export function fetchCompanyMembersWithSearch(searchValue) {
  return axios.get(`${API_BASE}/api/accounts/company/members/`, {
    headers: getAuthHeaders(),
    params: searchValue ? { search_value: searchValue } : {}
  })
    .then(res => res.data)
    .catch(async err => {
      const errorMsg = err.response?.data?.error || err.message || 'Failed to fetch company members';
      throw new Error(errorMsg);
    });
}

// Fetch roles and reporting managers
export function fetchCollection() {
  return axios.get(`${API_BASE}/api/accounts/collection/?type=role,reporting_manager`, { headers: getAuthHeaders() })
    .then(res => res.data)
    .catch(err => { throw new Error(err.response?.data?.error || err.message || 'Failed to fetch collection'); });
}

// Register a new member
export function registerMember(data) {
  return axios.post(`${API_BASE}/api/accounts/register/`, data, { headers: getAuthHeaders() })
    .then(res => res.data)
    .catch(err => { throw new Error(err.response?.data?.error || err.message || 'Failed to register member'); });
}

// Update an existing member
export function updateMember(id, data) {
  return axios.put(`${API_BASE}/api/accounts/company/members/${id}/`, data, { headers: getAuthHeaders() })
    .then(res => res.data)
    .catch(err => { throw new Error(err.response?.data?.error || err.message || 'Failed to update member'); });
}

// Fetch company holidays
export function fetchCompanyHolidays() {
  return axios.get(`${API_BASE}/api/employee/holidays/`, { headers: getAuthHeaders() })
    .then(res => res.data)
    .catch(err => { throw new Error(err.response?.data?.error || err.message || 'Failed to fetch company holidays'); });
}
